module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_Wood.03e5fd67.jpg";